import moment from 'moment'

moment.locale('pt-br')

export default moment


// WEBPACK FOOTER //
// ./src/shared/helpers/moment.js